
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__lang-message",
  "use": "icon__lang-message-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 18\" id=\"icon__lang-message\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M1.5 3C.676 3 0 3.676 0 4.5v8c0 .824.676 1.5 1.5 1.5H3v2.434L6.652 14H12.5c.824 0 1.5-.676 1.5-1.5v-8c0-.824-.676-1.5-1.5-1.5h-11zm0 1h11c.281 0 .5.219.5.5v8c0 .281-.219.5-.5.5H6.348L4 14.566V13H1.5a.494.494 0 0 1-.5-.5v-8c0-.281.219-.5.5-.5zm1 1c-.277 0-.5.223-.5.5V10h1V9h2v1h1V6.785a.504.504 0 0 0-.172-.379l-1.5-1.285A.51.51 0 0 0 4 5H2.5zM3 6h.813L5 7.016V8H3V6zm6 1v1H7v1h2.875c-.105.188-.227.39-.379.594-.07.097-.16.183-.238.277-.356-.328-.625-.621-.625-.621l-.766.64s.278.305.649.657C8.098 10.817 7.602 11 7 11v1c.934 0 1.7-.34 2.3-.797.579.422 1.282.797 2.075.797v-1c-.402 0-.89-.219-1.34-.508.086-.101.188-.199.262-.3.324-.434.55-.864.703-1.192h1V8h-2V7H9z\" /><path d=\"M0 0h14v18H0z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconLangMessageIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__lang-message" {...restProps} />
    })
  